import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { ComplexSuggestedItem } from '../../../../ui/gzComplexEnumList/types';
import {
  PhasrBehavioralProfileIdentitiesResponse,
  PhasrRecommendationsEndpoint,
  PhasrRecommendationsMethod,
} from '../../types';
import {
  WEB_COMPONENT_PHASR_MONITORED_RULES,
  WEB_COMPONENT_PHASR_MONITORED_RULES_GRID,
  WEB_COMPONENT_PHASR_RECOMMENDATIONS,
  WEB_COMPONENT_PHASR_RECOMMENDATIONS_GRID
} from '../../../../webcomponents.constants';
import { PhasrRecommendationsGridWebComponent } from '../../component/PhasrRecommendationsGridWebComponent';
import { PhasrMonitoredRulesGridWebComponent } from '../../../../phasrMonitoredRules/phasrMonitoredRulesGrid';

export class PhasrBevahioralProfileIdentitiesDataProvider {
  static getExtraFilters(): Array<any> {
    const grid = document.querySelector(WEB_COMPONENT_PHASR_RECOMMENDATIONS)?.shadowRoot?.querySelector(WEB_COMPONENT_PHASR_RECOMMENDATIONS_GRID) as PhasrRecommendationsGridWebComponent;

    if (!grid) {
      return [''];
    }
    return [grid.getCompanyIdFilterValue()];
  }

  static getExtraFiltersForRules(): Array<any> {
    const grid = document.querySelector(WEB_COMPONENT_PHASR_MONITORED_RULES)?.shadowRoot?.querySelector(WEB_COMPONENT_PHASR_MONITORED_RULES_GRID) as PhasrMonitoredRulesGridWebComponent;

    if (!grid) {
      return [''];
    }
    return [grid.getCompanyIdFilterValue()];
  }

  /**
   *
   * @param page
   * @param limit
   * @param searchString
   * @param filters
   * @protected
   */
  static async getRemoteData(
    page: number,
    limit: number,
    searchString: string = '',
    filters: Array<any> = []
  ): Promise<Array<PhasrBehavioralProfileIdentitiesResponse>> {
    return await ConsoleRequest.createRequest<Array<PhasrBehavioralProfileIdentitiesResponse>>({
      dataProviderType: DataProviderType.CORE,
      endpoint: PhasrRecommendationsEndpoint.BEHAVIORAL_PROFILES,
      method: PhasrRecommendationsMethod.GET_PHASR_BEHAVIORAL_PROFILE_IDENTITIES,
      payload: {
        page: page,
        limit: limit,
        companyId: filters[0],
        filter: [
          {
            property: 'behavioralProfileIdentityName',
            value: searchString,
          }
        ]
      },
    });
  }

  /**
   *
   * @param response
   * @protected
   */
  static convertResponse(response: Array<any>): ComplexSuggestedItem[] {
    return response.map((item: any) => {
      return {
        label: item['behavioralProfileIdentityName'],
        value: item['behavioralProfileIdentity'],
      };
    });
  }
}
